const PREFIX = "/home"
import http from "@/util/http.js"
import { downloadPost } from "@/util/utils"

export default {
    async downloadModelo()
    {
        return await downloadPost(PREFIX +  "/download-modelo")
    },
    async getPreviewManual(customConfig) {
		return await http.post(PREFIX +  "/download-manual", {
			customConfig,
			responseType: 'arraybuffer',
		})
	},
    async getPreviewVideo(customConfig) {
		return await http.post(PREFIX +  "/download-video", {
			customConfig,
			responseType: 'arraybuffer',
		})
	}
}